import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { PersonalInfosChangeData } from '../../interfaces/PersonalInfosChangeData';
import PersonalInformationsConfirmationPageContent from './PersonalInformationsConfirmationPageContent/PersonalInformationsConfirmationPageContent';

export interface PersonalInformationsConfirmationPageProps {
  returnPage: string;
}

const PersonalInformationsConfirmationPage: FC<PersonalInformationsConfirmationPageProps> = ({ returnPage }) => {
  const location = useLocation();
  const changeData = location.state as { data: PersonalInfosChangeData };

  return (
    <PersonalInformationsConfirmationPageContent returnPage={returnPage} changeData={changeData?.data} />
  );
};
export default PersonalInformationsConfirmationPage;
